import { Address } from "@redotech/account-common/address";
import * as z from "zod";

export const InteractiveMapLocationSchema = z.object({
  name: z.string(),
  address: z.object({
    address1: z.string(),
    address2: z.string().nullish(),
    city: z.string(),
    state: z.string().nullish(),
    zip: z.string(),
    country: z.string(),
  }),
  geo: z.object({ latitude: z.number(), longitude: z.number() }).nullish(),
  distance: z.string().nullish(),
  hours: z.record(z.string(), z.string()).nullish(),
  outsideConfiguredRadius: z.boolean().nullish(),
  configuredRadiusMiles: z.number().nullish(),
});

export type InteractiveMapLocation = z.infer<
  typeof InteractiveMapLocationSchema
>;

export function parseAddressAsInteractiveMapLocation(
  address: Address,
): InteractiveMapLocation {
  return {
    name: address.name,
    address: {
      address1: address.street1,
      address2: address.street2,
      city: address.city,
      state: address.state,
      zip: address.zip,
      country: address.country,
    },
    geo:
      address.longitude !== undefined && address.latitude !== undefined
        ? { latitude: address.latitude, longitude: address.longitude }
        : undefined,
  };
}
